export enum ItemStatusNamesEnum {
  PUBLISHED = 'Published',
  DRAFT = 'Draft',
}
